export default function Error() {
  return <div>Error: {window.location.pathname} page not found</div>;
}
